import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { classNames } from "../App"
import _ from "lodash"

const GET_ELECTION = gql`
  query GetPortfolios {
    portfolios {
      _id
      order
      name
      candidates {
        _id
        order
        name
        votes
      }
      votes
    }
    usersLength
  }
`

export default function Election() {

  const { data } = useQuery(GET_ELECTION, {
    pollInterval: 1000
  })

  return (
    <div className="grid grid-cols-1 gap-4 lg:col-span-2">
      <div className="">
        <div className="gap-6 grid md:grid-cols-2">
          {_.chain(data?.portfolios)?.orderBy("order")?.map((portfolio, idx) => (
            <div key={idx} className="p-6 space-y-6 rounded-lg bg-white overflow-hidden shadow">
              <div className="flex items-center justify-center">
                <h3 className="text-lg md:text-lg text-gray-800 font-light text-center">
                  {portfolio?.name}
                </h3>
              </div>
              {_.orderBy(portfolio.candidates, "votes", "desc").map((candidate, id) => {
                let percentage = _.round((candidate.votes / (data.usersLength === 0 ? 1 : data.usersLength) * 100), 2);
                let isHighest = _.maxBy(portfolio.candidates, "votes")._id === candidate._id;
                return (<div key={id}>
                  <div className="flex justify-between items-center">
                    <span className="text-md text-gray-700 font-light">
                      {candidate?.name}
                    </span>
                    <span className=" text-sm text-gray-700 font-light">
                      {candidate?.votes} Votes ({percentage}%)
                    </span>
                  </div>
                  <div className="mt-2">
                    <div className={classNames(
                      isHighest ? "bg-green-50" : "bg-gray-50",
                      "relative  h-8 rounded-md"
                      )}>
                      <div className={classNames(
                      isHighest ? "bg-green-400" : "bg-gray-400",
                      "absolute left-0 inset-y-0 rounded-l-md"
                      )}
                      style={{width: `${percentage}%`}}
                      />
                    </div>
                  </div>
                </div>
                )
              })}
            </div>
          )).value()}
        </div>
      </div>
    </div>
  )
}
